import { useTranslation } from 'react-i18next'

import { Typography, Divider } from '@percent/lemonade'
import styles from './Footer.module.scss'

export function Footer() {
  const { t } = useTranslation()

  return (
    <footer className={styles.footer}>
      <Divider />
      <Typography className={styles.typography}>
        <span role="img">©</span>
        {` ${new Date().getFullYear()} `}
        {t('typography.wapMadeWith')}
      </Typography>
    </footer>
  )
}
